// src/scenes/Agents/NewAgentPage.jsx
import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import Form from '@rjsf/mui';
import validator from '@rjsf/validator-ajv8';
import schema from '../../assistantSchema';
import Header from '../../components/Header';
import axios from 'axios';

export default function NewAgentPage() {
  const navigate = useNavigate();
  const [voices, setVoices] = useState([]);

  // fetch voices for dropdown
  useEffect(() => {
    axios.get('/api/vapi/voices')
      .then(({ data }) => setVoices(data))
      .catch(console.error);
  }, []);

  const dynamicSchema = useMemo(() => {
    const s = JSON.parse(JSON.stringify(schema));
    if (voices.length) {
      s.properties.voice.properties.voice.enum = voices.map(v => v.id);
      s.properties.voice.properties.voice.enumNames = voices.map(v => v.name);
    }
    return s;
  }, [voices]);

  const uiSchema = {
    model: {
      firstMessage: { 'ui:widget': 'textarea', 'ui:options': { rows: 3 } },
      systemPrompt:  { 'ui:widget': 'textarea', 'ui:options': { rows: 8 } },
    }
  };

  // blank starter form
  const blankFormData = {
    name: '',
    description: '',
    model: { provider: 'openai', model: 'gpt-4o-mini' },
    firstMessage: '',
    systemPrompt: '',
    maxTokens: 250,
    temperature: 0.5,
    voice: { provider: 'vapi', voice: '', punctuationBoundaries: [',', '.', '!', '?', ';'] },
    transcriber: {},
    voicemailMessage: '',
    endCallFunctionEnabled: false,
    endCallMessage: '',
    forwardingPhoneNumber: '',
    clientMessages: [],
    serverMessages: [],
    backgroundSound: 'none',
    backgroundDenoisingEnabled: false,
    startSpeakingPlan: {},
    server: {},
  };

  const onSubmit = async ({ formData }) => {
    try {
      const payload = {
        name:        formData.name,
        description: formData.description,
        model: {
          provider: formData.model.provider,
          model: {
            model:      formData.model.model,
            maxTokens:  formData.maxTokens,
            temperature:formData.temperature,
            messages: [
              { role: 'system', content: formData.systemPrompt }
            ]
          }
        },
        firstMessage: formData.firstMessage,
        voice: {
          voiceId: formData.voice.voice,
          provider: formData.voice.provider,
          inputPunctuationBoundaries: formData.voice.punctuationBoundaries
        },
        transcriber: formData.transcriber,
        voicemailMessage: formData.voicemailMessage,
        endCallFunctionEnabled: formData.endCallFunctionEnabled,
        endCallMessage: formData.endCallMessage,
        forwardingPhoneNumber: formData.forwardingPhoneNumber,
        clientMessages: formData.clientMessages,
        serverMessages: formData.serverMessages,
        backgroundSound: formData.backgroundSound,
        backgroundDenoisingEnabled: formData.backgroundDenoisingEnabled,
        startSpeakingPlan: formData.startSpeakingPlan,
        server: formData.server,
      };
      const { data } = await axios.post('/api/vapi/assistants', payload);
      alert('Created successfully!');
      navigate(`/agents/${data.id}`);
    } catch (e) {
      console.error(e);
      alert('Create failed: ' + (e.response?.data?.error || e.message));
    }
  };

  return (
    <Box m="20px">
      <Header title="Create new assistant" subtitle="Fill out all fields below" />
      <Form
        schema={dynamicSchema}
        uiSchema={uiSchema}
        validator={validator}
        formData={blankFormData}
        onSubmit={onSubmit}
      >
        <Box sx={{ mt: 2 }}>
          <Button type="submit" variant="contained">Create</Button>
        </Box>
      </Form>
    </Box>
  );
}
